<template>
  <div id="main-app">
    <div v-if="basePageLoaded">
      <div v-if="user && showImpersonateBanner" class="white red-bg py1 center sticky top-0 z4">
        Vous êtes connecté pour le compte de: {{ user.firstname }} {{ user.lastname }} sur le site SPEEDBOAT
        <a class="pointer ml2 grey-bg p1" @click="logout">
          <i class="icon icon-logout mr1"></i>
          <span>Déconnexion</span>
        </a>
      </div>
      <header>
        <div class="col-12 px3 flex justify-between top-menu">
          <div class="col-4 flex items-center">
            <span class="flex items-center pointer full-height" @click="goToHome()">
              <img class="logo-ucpa" src="/espacepersonnel/fonts/logo.svg">
            </span>
          </div>
          <div class="col-8 flex items-center justify-end pointer">
            <!-- <span class="h6n bold items-center px1 white">Jean Dupont</span> -->
            <span class="pointer" style="height: 30px" @click="goToHome()">
              <i class="icon-cancel" style="font-size: 30px"></i>
            </span>
          </div>
        </div>
      </header>
      <div class="page-body">
        <Breadcrumb />

        <div class="flex flex-wrap full-height content-stretch">
          <div id="menu-block">
            <Menu id="menu-desktop" class="xs-hide sm-hide mt3" :sessions-count="sessionsCount" />
          </div>
          <div id="content-block" class="grey-bg">
            <div id="scrollable-content" class="scrollable" :style="scrollableHeight">
              <div class="full-height grey-bg">
                <router-view />
              </div>
            </div>
            <Menu id="menu-mobile" class="md-hide lg-hide white-bg" style="height: 75px" :sessions-count="sessionsCount" />
          </div>
        </div>
      </div>
    </div>
    <LoadingOverlay />
    <notifications position="bottom left" group="impersonate" />
    <notifications position="top center" group="update-user" class="fixed top-0 left-0 right-0 flex justify-center pt4 z5" :close-on-click="false">
      <template #body="props">
        <div class="flex items-center justify-between red-bg border rounded px3 py2 shadow" style="min-width: 500px;">
          <div class="flex-1">
            <p class="m0 white h6n">
              {{ props.item.text }}
            </p>
          </div>
          <button class="ml2 pointer red-bg border-none flex items-center justify-center" style="width: 24px; height: 24px" @click="props.close">
            <svg width="16" height="16" viewBox="0 0 24 24" class="white" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor" />
            </svg>
          </button>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeMount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import Menu from '@/components/menu/Menu';

import Breadcrumb from '@/components/common/Breadcrumb';
import LoadingOverlay from '@/components/common/LoadingOverlay';

import { getUser, getSiteConfiguration, isImpersonateMode } from '@/mixins/requests';

export default {
  components: {
    Menu,
    Breadcrumb,
    LoadingOverlay
  },
  setup () {
    const route = useRoute();
    const router = useRouter();

    const store = useStore();

    const user = computed(() => store.state.user);

    const showImpersonateBanner = computed(() => store.state.impersonateData);

    // const returnUrl = cookies.get('return_url');
    // TODO Disable until proper cookie implementation client
    // console.log('teste',VueCookies)
    // const returnUrl = computed(() => {
    //   let link = '/';
    //   const cookieLink = this && this.$cookies.get('return_url');
    //   if (cookieLink && !returnUrl.value.includes('/espacepersonnel')) {
    //     link = cookieLink;
    //   }

    //   return link;
    // });

    const returnUrl = ref('/');

    const basePageLoaded = ref(false);
    const sessionsCount = ref(0);
    const windowWidth = ref(window.innerWidth);
    const windowHeight = ref(window.innerHeight);

    const scrollableHeight = computed(() => {
      const computedHeight = [`${windowHeight.value}px`];

      // Top Header
      computedHeight.push('60px');

      // Impersonate banner height when visible
      if (showImpersonateBanner.value) {
        computedHeight.push('45px');
      }

      // Bottom menu only available in mobile
      if (windowWidth.value < 832) {
        computedHeight.push('76px');
      }

      // Base breadcrumb only available in some contexts
      if (route.meta.breadcrumb) {
        computedHeight.push('70px');
      }

      return `height: calc(${computedHeight.join(' - ')})`;
    });

    onMounted(() => {
      window.onresize = () => {
        windowWidth.value = window.innerWidth;
        windowHeight.value = window.innerHeight;
      };
    });

    onBeforeMount(async () => {
      store.commit('setLoading', true);

      await router.isReady();

      const { impersonateData } = route.query;

      if (impersonateData) {
        store.commit('setImpersonateData', impersonateData);
        const response = await isImpersonateMode();

        if (!response.data) {
          store.commit('setImpersonateData', null);
        }
        router.replace({ query: {} });
      }

      await getSiteConfiguration();

      const auxUser = await getUser();
      if (!auxUser) {
        return null; // Loading and redirect to SSO
      }

      // sessionsCount.value = await getParticipantsSessionsCount();

      store.commit('setLoading', false);

      basePageLoaded.value = true;
      store.commit('setLoading', !basePageLoaded.value);
    });

    const goToHome = () => {
      // let url = `/${store.state.agency && store.state.agency !== 'speedboat' ? `partenaire/${store.state.agency}` : ''}`;
      let url = store.getters.getSiteUrl();

      if (store.state.impersonateData) {
        url += `?impersonateData=${store.state.impersonateData}`;
      }
      store.commit('setImpersonateData', null);

      window.location.href = url;
    };

    function logout () {
      store.commit('setImpersonateData', null);
      window.location.href = '/af/logout';
    }

    return {
      user,
      showImpersonateBanner,
      basePageLoaded,
      returnUrl,
      goToHome,
      logout,
      windowWidth,
      scrollableHeight,
      sessionsCount
    };
  }
};
</script>

<style>
/* Imports of static css files */
@import './assets/css/common.css';
html {
  overflow: hidden;
}

header {
  border-bottom: 1px solid #e4e9ee;
  height: 60px;
}

.logo-ucpa {
  width: 55px;
  filter: invert(1);
}

.top-menu {
  /* source: https://cssgradient.io/ */
  /*
  background: rgb(132,164,201);
  background: linear-gradient(90deg, rgba(132,164,201,1) 0%, rgba(179,199,223,1) 43%, rgba(110,140,176,1) 100%);
  */

  background-color: white;
}

#menu-block {
  width: 0%;
}

#menu-mobile {
  border-top: 1px solid #e4e9ee;
}

.page-body {
  height: calc(100vh - 60px);
}

#content-block {
  width: 100%;
}

@media screen and (min-width: 52rem) {
  #menu-block {
    width: 20%;
    border-right: 1px solid #e4e9ee;
  }

  #content-block {
    border-bottom: 0px;
    width: 80%;
  }
}
</style>
